import type {FadeBackgroundProps} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/fade-background/fade-background.types';

export interface AudioItemFadeBackgroundProps extends FadeBackgroundProps {
  audioId: string;
  className?: string;
  widthPerSecond: number;
}

export const LEFT_PADDING_FOR_FADE_BACKGROUND = 22;
export const FADE_SLIDER_HANDLE_RADIUS = 8;
export const FADE_SLIDER_CONTAINER_RIGHT_PADDING = 4;
export const FADE_SLIDER_GAP = 8;
export const FADE_SLIDER_INTERNAL_PADDING = 1;
